import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Select.module.scss.js';

var Select = (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = function () {
            _this.setState({ isActive: !_this.state.isActive });
        };
        _this.onBlur = function () {
            _this.hide();
        };
        _this.onEscape = function (e) {
            if (e.keyCode === 27 && _this.state.isActive) {
                e.preventDefault();
                _this.hide();
            }
        };
        _this.onItemChange = function (itemSelected) {
            _this.setState({ itemSelected: itemSelected });
            _this.props.onItemChange(itemSelected.value);
            _this.hide();
        };
        var itemSelected = _this.props.items.find(function (obj) { return obj.value === _this.props.itemValueSelected; });
        if (itemSelected) {
            _this.state = {
                isActive: false,
                itemSelected: {
                    name: itemSelected.name,
                    value: itemSelected.value,
                },
            };
        }
        return _this;
    }
    Select.prototype.componentDidMount = function () {
        var _this = this;
        var itemSelected = this.props.items.find(function (obj) { return obj.value === _this.props.itemValueSelected; });
        if (itemSelected) {
            this.setState(function (prevState) { return ({
                isActive: false,
                itemSelected: {
                    name: itemSelected.name,
                    value: itemSelected.value,
                },
            }); });
        }
        document.addEventListener('keydown', this.onEscape, true);
    };
    Select.getDerivedStateFromProps = function (nextProps, prevState) {
        var itemSelected = nextProps.items.find(function (obj) { return obj.value === nextProps.itemValueSelected; });
        return {
            itemSelected: itemSelected,
        };
    };
    Select.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onEscape, true);
    };
    Select.prototype.hide = function () {
        this.setState({ isActive: false });
    };
    Select.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var classNameSelect = classNames(styles.select, (_a = {},
            _a[styles.isActive] = this.state.isActive,
            _a));
        var classNameDropdown = classNames(styles.dropdown, (_b = {},
            _b[styles.isDropped] = this.state.isActive,
            _b));
        var selectItems = this.props.items.map(function (item, index) {
            var _a;
            var classNameItem = classNames(styles.item, (_a = {},
                _a[styles.isSelected] = _this.state.itemSelected.value === item.value,
                _a));
            return (React.createElement("li", { className: classNameItem, key: index, onClick: function () {
                    _this.onItemChange(item);
                } }, item.name));
        });
        return (React.createElement("div", { className: classNames(styles.container, this.props.className), tabIndex: 1, onBlur: this.onBlur },
            React.createElement("div", { className: classNameSelect, onClick: this.onToggle }, this.state.itemSelected.name),
            React.createElement("menu", { className: classNameDropdown }, selectItems)));
    };
    return Select;
}(React.Component));

export { Select as default };
//# sourceMappingURL=Select.js.map
